import {
  VALIDATE_GROUP_DETAILS,
  VALIDATE_SEARCH_DETAILS,
  VALIDATE_FLIGHT_OFFERS,
  VALIDATE_ANCILLARIES,
  VALIDATE_BOOKER_DETAILS,
} from '../actions/validation'
import { RESET_FLOW } from '../actions/reset'

export const initialState = {
  searchDetails: {
    primary: {
      inboundAirport: false,
      outboundAirport: false,
      inboundRoute: false,
      outboundRoute: false,
    },
    secondary: {
      inboundAirport: false,
      outboundAirport: false,
      inboundRoute: false,
      outboundRoute: false,
    },
    routeCombination: false,
  },
  flightOffers: {},
  ancillaries: {
    holdLuggage: true,
    SKIS: true,
    GOLF: true,
  },
  bookerDetails: {
    salutation: false,
    firstName: false,
    lastName: false,
    emailAddress: false,
    phoneNumber: false,
  },
  groupDetails: {
    party: {
      minGroupSize: true,
      minAdult: true,
      minAdultPerBaby: true,
    },
    groupName: false,
  },
}

function validation(state = initialState, action = {}) {
  switch (action.type) {
    case VALIDATE_GROUP_DETAILS:
      return {
        ...state,
        groupDetails: {
          ...state.groupDetails,
          ...action.data,
        },
      }
    case VALIDATE_SEARCH_DETAILS:
      return {
        ...state,
        searchDetails: {
          ...state.searchDetails,
          ...action.data,
        },
      }
    case VALIDATE_FLIGHT_OFFERS:
      return {
        ...state,
        flightOffers: {
          ...state.flightOffers,
          ...action.data,
        },
      }
    case VALIDATE_ANCILLARIES:
      return {
        ...state,
        ancillaries: {
          ...state.ancillaries,
          ...action.data,
        },
      }
    case VALIDATE_BOOKER_DETAILS:
      return {
        ...state,
        bookerDetails: {
          ...state.bookerDetails,
          ...action.data,
        },
      }
    case RESET_FLOW:
      return initialState
    default:
      return state
  }
}

export default validation
